export const MAIN_PAGE = '/'
export const LOGIN_PAGE = '/login'
export const CONSTRUCTOR_PAGE = '/constructor'